import CardData from '../types/CardData'
import Money from '../types/Money'
import { AcsTransactionResult } from '../types/TransactionResult'
import api from './api'

export const payCard = async (
    paymentPageId: string,
    cardData: CardData,
    extraFieldsData: Record<string, string>,
    money?: Money,
): Promise<AcsTransactionResult> => {
    const [expMonth, expYear] = cardData.exp.split('/')

    return await api('/api/payment-page/pay/card', {
        paymentPageId: paymentPageId,
        card: {
            pan: cardData.pan.replace(/\D/g, ''),
            expMonth: expMonth,
            expYear: `20${expYear}`,
            cvv: cardData.cvv,
            name: cardData.name,
        },
        ...money ? {
            money: {
                amount: parseFloat(money.amount) * 100,
                currency: money.currency,
            }
        } : {},
        extraFields: extraFieldsData,
    }) as AcsTransactionResult
}
